import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
const n = t({
  type: { default: "collapsibleSectionSummary" }
}), p = {
  defining: !0,
  content: "paragraph | heading | subheading | subheading3 | subheading4 | codeBlock",
  attrs: n,
  parseDOM: [
    {
      tag: "summary"
    }
  ],
  toDOM() {
    return ["summary", 0];
  }
}, l = t({
  type: { default: "collapsibleSectionContent" }
}), S = {
  defining: !0,
  content: "(block|list|table)+",
  attrs: l,
  parseDOM: [
    {
      tag: `div.${e.collapsibleSectionContent}`
    }
  ],
  toDOM() {
    return ["div", { class: e.collapsibleSectionContent }, 0];
  }
}, a = t({
  type: { default: "collapsibleSection" },
  open: { default: !0 }
}), u = {
  inline: !1,
  defining: !0,
  content: "collapsibleSectionSummary collapsibleSectionContent",
  group: "block",
  attrs: a,
  parseDOM: [
    {
      tag: "details"
    }
  ],
  toDOM(o) {
    return ["details", o.attrs.open ? { open: "true" } : {}, 0];
  }
};
export {
  S as collapsibleSectionContentSpec,
  u as collapsibleSectionSpec,
  p as collapsibleSectionSummarySpec
};
